import {
  Box,
  Stack,
  Grid,
  Typography,
  Card,
  CardActions,
  CardContent,
  Link,
  Select,
  InputAdornment,
  MenuItem,
  Button,
  Dialog,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import LandingLayout, { useLanding } from "components/landing/LandingLayout";
import {
  AppFormikTextArea,
  AppFormikTextField,
  AppFormikTextFieldNumber,
  AppPrimaryButton,
} from "shared/components/AppComponents";
import { Formik } from "formik";
import { ContactUsSchema } from "shared/helpers/Schema";
import axios from "axios";
import { useEffect, useState } from "react";
import { GENERAL_DATA } from "shared/helpers/Constants";
import AccordionFaqs from "components/landing/Accordion";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ApplyNowButton = () => {
    const { setEarlyAccess } = useLanding();

    const showEarlyAccess = () => {
      setEarlyAccess(true);
    };

    return (
      <Button
        variant="contained"
        sx={{
          height: "32px",
          borderRadius: "8px",
          backgroundColor: "#0053FD",
          color: "white",
          fontSize: "15px",
          padding: "0 16px",
          textTransform: "none",
          boxShadow: "none",
          width: "8.5rem",
        }}
        onClick={() => showEarlyAccess()}
      >
        Apply now
      </Button>
    );
  };

  const API_KEY = "568db595c6b8de3a2ec2ad348c172c0c";
  const FORM_ID = "252738748305061";

  const url = `https://api.jotform.com/form/${FORM_ID}/submissions?apiKey=${API_KEY}`;
  const [applySuccess, setApplySuccess] = useState(false);

  const handleSubmitForm = (formValues, formik) => {
    let formattedPhone = formValues.phoneNumber;

    formattedPhone = formattedPhone.replace(/^\+?61\s*/, "");

    formattedPhone = formattedPhone.replace(/[^\d]/g, "");

    formattedPhone = `+61 ${formattedPhone}`;

    const dataForm = [
      {
        "3": { first: formValues.firstName, last: formValues.lastName },
        "4": { text: formValues.email },
        "5": {
          full: formattedPhone,
        },
        "6": formValues.message,
      },
    ];

    axios
      .put(url, dataForm)
      .then((response) => {
        if (response.data.responseCode === 200) {
          setApplySuccess(true);
          formik.resetForm();
          setTimeout(() => {
            setApplySuccess(false);
          }, 3000);
        }
      })
      .catch((error) => {
        console.error(
          "Error submitting form:",
          error.response ? error.response.data : error.message
        );
      });
  };

  return (
    <LandingLayout>
      <Dialog open={applySuccess} onClose={() => setApplySuccess(false)}>
        <Box sx={{ padding: "24px", textAlign: "center" }}>
          <img src="/images/success.gif" width={120} />
          <Box sx={{ padding: "12px" }}>
            <Typography
              sx={{
                fontSize: "28px",
                lineHeight: "34px",
                fontWeight: 800,
                marginTop: "0.5rem",
              }}
            >
              We’ve got your details
            </Typography>
            <Typography
              sx={{
                fontSize: "17px",
                lineHeight: "22px",
                fontWeight: 400,
                marginTop: "0.5rem",
              }}
            >
              {" "}
              Please allow us 24-48 hrs to address your query.
            </Typography>
          </Box>
        </Box>
      </Dialog>

      <Box className="contact-wrapper">
        <Stack className="contact-container" direction="column" spacing={0}>
          <Box className="heading-contact-us">
            <Grid container spacing={5} direction="row">
              <Grid size={{ sm: 12, md: 7 }}>
                <Typography className="breadcrumb-contact">
                  Contact Us
                </Typography>

                <Typography
                  className="title-contact"
                  variant="h2"
                  sx={{
                    fontSize: "48px",
                    color: "#0A0A0A",
                    lineHeight: 1.2,
                  }}
                  //   fontSize: "clamp(45px, 4.21875vw - 9px, 72px)",
                  fontWeight={"600"}
                >
                  Need a <br />
                  Business Loan?
                </Typography>
                <Box className="content-contact-nav">
                  <Typography className="desc-contact">
                    Whether you`re ready to apply, have questions about our
                    lending solutions, or just want to explore your options,
                    we`re here to help.
                  </Typography>
                  <Grid container spacing={4} mb={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Card
                        variant="outlined"
                        sx={{
                          background: "#D6E1F6",
                          padding: "8px",
                          minHeight: "12rem",
                          border: "none",
                          borderRadius: "16px",
                        }}
                      >
                        <CardActions style={{ padding: "16px" }}>
                          <Stack
                            direction="row"
                            sx={{
                              width: "100%",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <img src="/images/chat.svg" />
                          </Stack>
                        </CardActions>
                        <CardContent>
                          <Typography
                            variant="h4"
                            fontSize={22}
                            fontWeight={600}
                          >
                            Chat
                          </Typography>
                          <Typography
                            sx={{ fontSize: "16px", color: "#474747" }}
                          >
                            Chat with us anytime between: 9am - 5pm AEST, Monday
                            to Friday
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <Card
                        variant="outlined"
                        sx={{
                          background: "#D6E1F6",
                          padding: "8px",
                          minHeight: "12rem",
                          border: "none",
                          borderRadius: "16px",
                        }}
                      >
                        <CardActions style={{ padding: "16px" }}>
                          <Stack
                            direction="row"
                            sx={{
                              width: "100%",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <img src="/images/mail.svg" />
                          </Stack>
                        </CardActions>
                        <CardContent>
                          <Typography
                            variant="h4"
                            fontSize={22}
                            fontWeight={600}
                          >
                            Email
                          </Typography>
                          <Typography
                            sx={{ fontSize: "16px", color: "#474747" }}
                          >
                            Send us an inquiry at
                          </Typography>
                          <a href="mailto:info@ezifin.com">info@ezifin.com</a>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid size={{ sm: 12, md: 5 }}>
                <Paper
                  elevation={3}
                  className="form-contact-us"
                  sx={{ boxShadow: "0px 24px 32px 0px #0000001A" }}
                >
                  <Box className="header-form" mb={"0.5rem"}>
                    <Typography variant="h4" fontWeight={"600"}>
                      Get in Touch
                    </Typography>
                    <Typography className="form-description">
                      Reach out to us at anytime
                    </Typography>
                    <Box className="content-form" mt={"1rem"}>
                      <Stack direction="row" spacing={2}></Stack>
                      {/* Formik */}
                      <Formik
                        enableReinitialize
                        validationSchema={ContactUsSchema}
                        validateOnMount
                        onSubmit={(formValues, formik) => {
                          handleSubmitForm(formValues, formik);
                        }}
                        initialValues={{
                          firstName: "",
                          lastName: "",
                          email: "",
                          phoneNumber: "",
                          message: "",
                        }}
                      >
                        {({ handleSubmit, errors, values, setSubmitting }) => {
                          console.log(errors);
                          return (
                            <form autoComplete="off">
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                  <AppFormikTextField
                                    variant="outlined"
                                    label="First name*"
                                    name="firstName"
                                  />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                  <AppFormikTextField
                                    variant="outlined"
                                    label="Last name*"
                                    name="lastName"
                                  />
                                </Grid>
                              </Grid>

                              <AppFormikTextField
                                variant="outlined"
                                label="Email address*"
                                name="email"
                              />
                              <AppFormikTextFieldNumber
                                variant="outlined"
                                label=""
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    padding: 0,
                                  },
                                }}
                                name="phoneNumber"
                                className="textfield-number"
                                notched={false}
                                outerLabel
                                placeholder="Phone number*"
                                inputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue="61"
                                        label="Age"
                                        onChange={(event: any) => {
                                          console.log(
                                            event.target.value as string
                                          );
                                        }}
                                      >
                                        <MenuItem value="61">
                                          <Box sx={{ display: "flex" }}>
                                            <img
                                              src="/images/au-rectangle.png"
                                              style={{
                                                position: "relative",
                                                left: "-0.2rem",
                                                height: "16px",
                                                width: "20px",
                                                top: "0.2rem",
                                                borderRadius: "4px",
                                              }}
                                            />
                                            <Typography
                                              sx={{
                                                position: "relative",
                                                fontSize: "16px",
                                                top: "0.05rem",
                                              }}
                                            >
                                              +61
                                            </Typography>
                                          </Box>
                                        </MenuItem>
                                      </Select>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <AppFormikTextArea
                                name="message"
                                notched={false}
                                label="Your message*"
                                placeholder=""
                                multiline
                                rows={3}
                              />
                              <Box mt={"1rem"}>
                                <AppPrimaryButton
                                  title="Submit"
                                  fullWidth
                                  className="submit-form"
                                  onClick={handleSubmit}
                                />
                              </Box>
                            </form>
                          );
                        }}
                      </Formik>
                    </Box>
                  </Box>
                  <Stack direction="row" className="contact-note" spacing={1}>
                    <Typography>
                      {`By submitting, you agree with
                                                our `}
                    </Typography>
                    <a
                      href="/terms-of-service"
                      target="_blank"
                      style={{
                        color: "black",
                        fontWeight: 500,
                      }}
                      className="footer-links"
                    >
                      Terms of Service
                    </a>
                    <Typography>{` & `}</Typography>
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      style={{
                        color: "black",
                        fontWeight: 500,
                      }}
                      className="footer-links"
                    >
                      Privacy Policy
                    </a>
                  </Stack>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box className="map-contact-us">
            <Grid container spacing={4} direction="row">
              <Grid
                size={{ sm: 12, md: 5 }}
                display="flex"
                justifyContent="center"
                mb={4}
              >
                <img
                  className="ezifin-logo"
                  src="/images/map.png"
                  alt="Office EZIFIN map"
                  onClick={() => {
                    window.open(
                      "https://maps.app.goo.gl/eHBKfWv8nezcCNDS9",
                      "_blank"
                    );
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Grid>
              <Grid
                size={{ sm: 12, md: 7 }}
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Box sx={{ marginLeft: "2rem" }}>
                  <Typography className="breadcrumb-hq">
                    Our Headquarters
                  </Typography>
                  <Typography className="title-hq" fontWeight={600}>
                    Where You Can Find Us
                  </Typography>
                  <Typography className="desc-hq">
                    "We`re based in Australia, supporting businesses and
                    individuals <br />
                    nationwide with tailored lending solutions."
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box className="faq-contact-us">
            <Grid container spacing={1} direction="row">
              <Grid size={{ sm: 12, md: 7 }}>
                <Typography className="title-faq">
                  Frequently asked <br />
                  questions
                </Typography>

                <Typography className="desc-faq">
                  Quick answers to help you get started.
                </Typography>
              </Grid>
              <Grid size={{ sm: 12, md: 5 }}>
                <AccordionFaqs faqsData={GENERAL_DATA} />
              </Grid>
            </Grid>
          </Box>
          <Box className="fund-contact-us">
            <Grid container spacing={1} direction="row">
              <Grid size={{ sm: 12, md: 7 }}>
                <Typography className="title-fund">
                  Ready to Unlock Your Funding?
                </Typography>

                <Typography className="desc-fund">
                  Apply today and experience fast approvals, flexible options,
                  and a lending <br />
                  process designed around your goals
                </Typography>
                <ApplyNowButton />
              </Grid>
              <Grid
                size={{ sm: 12, md: 5 }}
                justifyContent="center"
                display="flex"
                mt={5}
              >
                <img
                  className="app-logo"
                  src="/images/money.png"
                  alt="Perpetual Ltd."
                  width={"410px"}
                />
              </Grid>
            </Grid>
          </Box>
        </Stack>
      </Box>
    </LandingLayout>
  );
};

export default ContactUs;
